"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markMessageUnread = exports.INBOX_MARK_MESSAGE_UNREAD = void 0;
var INBOX_MARK_MESSAGE_UNREAD = "inbox/MARK_MESSAGE_UNREAD";
exports.INBOX_MARK_MESSAGE_UNREAD = INBOX_MARK_MESSAGE_UNREAD;

var markMessageUnread = function markMessageUnread(messageId) {
  return {
    type: INBOX_MARK_MESSAGE_UNREAD,
    payload: {
      messageId: messageId
    }
  };
};

exports.markMessageUnread = markMessageUnread;